import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Info from "../../../../../assets/icons/info-icon.svg";

const DateDescriptionTooltip = (props) => {
  let ref = React.useRef(null);

  const popover = (
    <Popover id="popover-basic">
      <Popover.Content>
        <div style={{ overflow: "auto" }}>{props.description[0]}</div>
      </Popover.Content>
    </Popover>
  );
  return (
    <OverlayTrigger
      ref={(r) => (ref = r)}
      container={ref.current}
      trigger={["click", "hover"]}
      placement="right"
      overlay={popover}
      rootClose
    >
      <img
        src={Info}
        alt="Info Icon"
        style={{
          height: "12px",
          width: "12px",
          margin: "10px 10px 6px 0px",
        }}
      />
    </OverlayTrigger>
  );
};
export default DateDescriptionTooltip;
